import React, { useContext, useRef } from 'react';
import { useActor } from '@xstate/react';
import { GlobalStateContext } from '../../state/app/index';
import CreatableSelect from 'react-select/creatable';

import logger from '../../logger';

const NotebookSelectorForNote = () => {
  const notebookSelectorRef = useRef(null);
  const globalServices = useContext(GlobalStateContext);
  const [appState, sendAppState] = useActor(globalServices.appState);
  const { selectedNote, notebooksIterable } = appState.context;

  // Debug logging
  console.log('NotebookSelectorForNote - Debug Info:', {
    selectedNote,
    notebooksIterable,
    notebooksIterableLength: notebooksIterable?.length,
    hasNotebooksIterable: !!notebooksIterable,
    appStateContext: appState.context,
  });

  const handleNotebookChange = (selectedOption) => {
    console.log(`Option selected:`, selectedOption);

    if (!selectedOption.__isNew__) {
      const noteObject = {
        ...selectedNote,
        notebook_id: selectedOption.value,
      };

      sendAppState({
        type: 'saveNote',
        data: {
          noteObject,
        },
      });
    }

    logger.error(
      selectedOption,
      'NotebookSelector: handleNotebookChange - new notebook'
    );
  };

  const handleMenuOpen = () => {
    console.log('NotebookSelectorForNote: Menu opened');
  };

  const handleMenuClose = () => {
    console.log('NotebookSelectorForNote: Menu closed');
  };

  const handleInputChange = (inputValue, actionMeta) => {
    console.group('Input Changed');
    console.log(inputValue);
    console.log(`action: ${actionMeta.action}`);
    console.groupEnd();
  };

  const renderNotebookItems = () => {
    // Handle empty or undefined data
    if (
      !notebooksIterable ||
      !Array.isArray(notebooksIterable) ||
      notebooksIterable.length === 0
    ) {
      console.warn(
        'NotebookSelectorForNote: notebooksIterable is empty or undefined',
        {
          notebooksIterable,
          selectedNote,
        }
      );
      return (
        <div className="notebook-selector-error">No notebooks available</div>
      );
    }

    let currentNotebook = {};
    const options = notebooksIterable.map((notebook, index) => {
      const notebookOption = {
        value: notebook.notebook_id,
        label: notebook.notebook_name,
      };

      // Set the current notebook if it matches
      if (notebook.notebook_id === selectedNote?.notebook_id) {
        currentNotebook = notebookOption;
      }

      return notebookOption;
    });

    console.log('NotebookSelectorForNote - Options:', {
      options,
      currentNotebook,
      selectedNoteNotebookId: selectedNote?.notebook_id,
    });

    return (
      <CreatableSelect
        name="form-field-name"
        className="react-select-container"
        classNamePrefix="notebook-select"
        onChange={handleNotebookChange}
        onInputChange={handleInputChange}
        onMenuOpen={handleMenuOpen}
        onMenuClose={handleMenuClose}
        options={options}
        value={currentNotebook}
        ref={notebookSelectorRef}
        styles={{
          menu: (provided) => ({
            ...provided,
            zIndex: 20000,
            position: 'absolute',
            width: 'max-content',
            minWidth: '100%',
          }),
          menuPortal: (provided) => ({
            ...provided,
            zIndex: 20000,
          }),
        }}
        isSearchable={true}
        isClearable={false}
        placeholder="Select notebook..."
        menuPortalTarget={document.body}
        menuPosition="fixed"
      />
    );
  };

  return <div className="notebook-selector note">{renderNotebookItems()}</div>;
};

export default NotebookSelectorForNote;
